import { createEffect } from 'effector';
import { createFetching } from '@lib/effector-utils';

import { history } from '@lib/routing';
import * as commonApi from '../api';

// Events
export const createMeetingRequesting = createEffect('meeting create requested');
export const updateMeetingRequesting = createEffect('meeting update requested');

// Set thunks
createMeetingRequesting.use(data => commonApi.createMeeting(data));
updateMeetingRequesting.use(data => commonApi.updateMeeting(data));

// Stores
export const $createMeetingFetching = createFetching(createMeetingRequesting);
export const $updateMeetingFetching = createFetching(updateMeetingRequesting);

// Side Effects
createMeetingRequesting.done.watch(() => {
  history.goBack();
});

// Navigate back after a successful update. The affected stores ($singleMeeting,
// $meetingsList) are refreshed from the update response in their own model
// files, so there's no need for a full page reload (which broke SPA behavior:
// it wiped app state and re-issued every request).
updateMeetingRequesting.done.watch(() => {
  history.goBack();
});
